var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.complete)?_c('div',{staticClass:"splash d-flex justify-center",class:{ 'hide': _vm.hide }},[_c('object',{attrs:{"data":_vm.svg}}),_c('v-progress-circular',{class:{ 'hide': !_vm.animationEnded },attrs:{"indeterminate":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }